module.exports = __webpack_public_path__ + "static/merchant_skies-26a3f0d4d7083f7abeb8ea7656ed0916.webp";